package fr.frux.feature.treeadd

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.runtime.setValue
import fr.frux.core.designsystem.components.ContributionGuideSheet

/**
 * L'introduction de la première création et le lien « Que puis-je recenser ? » ouvrent la même
 * feuille. Une feuille modale plutôt qu'un écran devant le formulaire : ce qui est dessous (carte
 * de l'assistant ou formulaire historique) reste composé pendant la lecture. Rend l'ouverture
 * manuelle, pour le lien.
 */
@Composable
internal fun rememberContributionGuide(
    introVisible: Boolean,
    onAcknowledge: () -> Unit,
): () -> Unit {
    var requested by rememberSaveable { mutableStateOf(false) }
    if (requested || introVisible) {
        val close = {
            requested = false
            onAcknowledge()
        }
        ContributionGuideSheet(onDismiss = close, onConfirm = close)
    }
    return { requested = true }
}
